<template>
  <v-dialog v-model="dialog" :max-width="590">
    <v-card>
      <v-card-title primary-title>
        <div class="headline">Actualizar Invitado</div>
      </v-card-title>
      <v-card-text>
        <v-form v-model="valid" ref="form">
          <v-subheader>Información General</v-subheader>
          <v-layout row justify-center>
            <v-flex xs10>
              <v-autocomplete
                label="Vehículos"
                :items="vehicles"
                v-model="selectedVehicles"
                item-text="plate"
                item-value="_id"
                multiple
                chips
                hint="El invitado tendrá acceso a estos vehículos"
                persistent-hint
              />
              <v-text-field
                label="Nombre"
                :count="44"
                :rules="nameRules"
                v-model="name"
                required
              />
              <v-text-field
                label="Usuario"
                :count="16"
                :rules="usernameRules"
                v-model="username"
                required
              />
            </v-flex>
          </v-layout>
          <v-subheader class="mb-3">Permisos</v-subheader>
          <v-layout row justify-center>
            <v-flex xs10>
              <v-switch
                v-for="permission in permissions" :key="permission.name"
                color="primary"
                :label="permission.displayName"
                v-model="selectedPermissions"
                :value="permission.name"
              ></v-switch>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
      <v-card-text>
        <v-alert color="error" icon="warning" v-model="errorAlert">{{ errorAlertText }}</v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click.native="dialog = false">cerrar</v-btn>
        <v-btn
          flat
          color="green"
          @click="createGuest"
          :loading="updatingGuest"
        >actualizar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'update-guest-dialog',
  props: {
    vehicles: {
      type: Array,
      default: function () {
        return []
      }
    },
    permissions: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data: function () {
    return {
      _id: null,
      selectedPermissions: [],
      dialog: false,
      valid: false,
      selectedVehicles: [],
      name: '',
      nameRules: [
        (value) => !!value || 'Nombre requerido',
        (value) => (value && value.length >= 4) || 'El nombre debe contener más de 4 caracteres',
        (value) => (value && value.length <= 44) || 'El nombre debe contener menos de 44 caracteres',
        (value) => /^[a-zA-Z ]+$/.test(value) || 'Nombre inválido'
      ],
      username: '',
      usernameRules: [
        (value) => !!value || 'Usuario requerido',
        (value) => (value && value.length >= 4) || 'El usuario debe contener más de 4 caracteres',
        (value) => (value && value.length <= 16) || 'El usuario debe contener menos de 16 caracteres',
        (value) => /^[a-zA-Z0-9]+$/.test(value) || 'Usuario inválido'
      ],
      updatingGuest: false,
      errorAlert: false,
      errorAlertText: ''
    }
  },
  methods: {
    createGuest: function () {
      if (!this.$refs.form.validate()) {
        return false
      }
      this.updatingGuest = true
      this.$emit('update-guest', {
        _id: this._id,
        guest: {
          vehicles: this.selectedVehicles || [],
          name: this.name.toUpperCase(),
          username: this.username.toLowerCase(),
          permissions: this.selectedPermissions || []
        }
      })
    },
    open: function ({ guest }) {
      this._id = guest._id
      this.selectedVehicles = guest.vehicles
      this.name = guest.name
      this.username = guest.username
      this.selectedPermissions = guest.permissions
      this.dialog = true
    },
    close: function () {
      this._id = null
      this.updatingGuest = false
      this.selectedVehicles = []
      this.selectedPermissions = []
      this.$refs.form.reset()
      this.errorAlert = false
      this.errorAlertText = ''
      this.dialog = false
    },
    displayError: function (err) {
      this.updatingGuest = false
      this.errorAlertText = err
      this.errorAlert = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UpdateGuestDialog.vue